import type { ReceiptTemplate } from '../schema';

export const jiffyLubeTemplate: ReceiptTemplate = {
  id: 'jiffy-lube',
  name: 'Jiffy Lube Receipt',
  brand: 'JIFFY LUBE',
  description: 'Jiffy Lube service receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'jl-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/jiffy-lube.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: ['#4892', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'jl-vehicle',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'customer', label: 'Customer:', value: 'JOHN DOE' },
          { id: 'vehicle', label: 'Vehicle:', value: '2022 TOYOTA CAMRY' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'mileage', label: 'Mileage:', value: '45,892' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'jl-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'SIGNATURE SERVICE OIL CHANGE', quantity: '1', price: '89.99', sku: '' },
          { id: '2', name: 'FULL SYNTHETIC OIL', quantity: '1', price: '0.00', sku: '' },
          { id: '3', name: 'OIL FILTER', quantity: '1', price: '0.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'jl-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '89.99', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '7.42', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '97.41', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'jl-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'jl-next',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'NEXT SERVICE DUE:\n48,892 MI or 04/04/2026\n\nLEAVE WORRY BEHIND', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

